module.exports = __webpack_public_path__ + "static/img/12.4094980.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/12.jpg
// module id = mQpP
// module chunks = 1